import { css } from '@linaria/core';

export const voyagerRootVars = css`
  :global() {
    :root {
      --voyager-color-primary: #440f95;
      --voyager-theme-color-brand-bg: #ffffff;
      --voyager-heading-font: 'PP Eiko', 'Playfair Display', serif;
      --voyager-body-font: 'Suisse Intl', 'Inter', sans-serif;

      --voyager-title-sm-size: 1rem;
      --voyager-title-md-size: 1.25rem;
      --voyager-title-lg-size: 1.5rem;

      --voyager-headline-sm-size: 1.25rem;
      --voyager-headline-md-size: 1.5rem;
      --voyager-headline-lg-size: 1.75rem;

      --voyager-display-md-size: 1.75rem;
      --voyager-display-lg-size: 2.25rem;
    }

    @media (min-width: 769px) {
      :root {
        --voyager-title-sm-size: 1.25rem;
        --voyager-title-md-size: 1.5rem;
        --voyager-title-lg-size: 2rem;

        --voyager-headline-sm-size: 1.5rem;
        --voyager-headline-md-size: 2rem;
        --voyager-headline-lg-size: 2.25rem;

        --voyager-display-md-size: 2.5rem;
        --voyager-display-lg-size: 3rem;
      }
    }
  }
`;
